import { Module } from 'vuex';

import { IndexState } from '../../models';

import { FetchInfoAction } from '../../store/index/actions/fetch-info.action';
import { ListJobsAction } from '../../store/index/actions/list-jobs.action';
import { ReadJobAction } from '../../store/index/actions/read-job.action';
import { ReimportJobAction } from '../../store/index/actions/reimport-job.action';
import { SubmitJobAction } from '../../store/index/actions/submit-job.action';
import { InfoGetter } from '../../store/index/getters/info.getter';
import { JobsGetter } from '../../store/index/getters/jobs.getter';
import { INDEX_CONSTS } from '../../store/index/index.consts';
import { SetInfoMutation } from '../../store/index/mutations/set-info.mutation';
import { SetJobsMutation } from '../../store/index/mutations/set-jobs.mutation';

export const INDEX_MODULE: Module<IndexState, any> = {
  namespaced: true,

  state: (): IndexState => {
    return {
      info: {
        name: undefined,
        token: undefined,
        feeds: []
      },
      jobs: []
    };
  },

  getters: {
    [INDEX_CONSTS.getters.info]: InfoGetter.execute,
    [INDEX_CONSTS.getters.jobs]: JobsGetter.execute
  },

  actions: {
    [INDEX_CONSTS.actions.fetchInfo]: FetchInfoAction.execute,
    [INDEX_CONSTS.actions.listJobs]: ListJobsAction.execute,
    [INDEX_CONSTS.actions.readJob]: ReadJobAction.execute,
    [INDEX_CONSTS.actions.submitJob]: SubmitJobAction.execute,
    [INDEX_CONSTS.actions.reimportJob]: ReimportJobAction.execute
  },

  mutations: {
    [INDEX_CONSTS.mutations.setInfo]: SetInfoMutation.execute,
    [INDEX_CONSTS.mutations.setJobs]: SetJobsMutation.execute
  }

};
